import React, { useEffect } from 'react'
import { FaHandshake, FaHouseChimney, FaShop, FaXmark } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';

//styles
import "./SideBar.css"

interface Props{
    open:Boolean
    setOpen:React.Dispatch<React.SetStateAction<boolean>>
    
}

const Sidebar = ({open, setOpen}:Props) => {
    const navigate = useNavigate();

    useEffect(() => {
        if (open) {
        document.body.classList.add('no-scroll');
        } else {
        document.body.classList.remove('no-scroll');
        }

        // Función de limpieza para remover la clase si el componente se desmonta
        return () => {
        document.body.classList.remove('no-scroll');
        };
    }, [open]); // El efecto se ejecuta cada vez que isSidebarOpen cambia
  return (
    <>
    <div className='SideBar-Component' style={{right:open ? "40vw" : "110vw"}}>


        <div className='SideBar-Header'>


            <div className='Sidebar-Header-logo'>
                <img src='/logo.png'  />
            </div>

            <div className='SideBar-Header-close'>
                <FaXmark onClick={()=>{setOpen(false)}} style={{cursor:"pointer", color:"#FFF"}}  />
            </div>

        </div>

        <div className='SideBar-Items'>
 

            {/* <div className='SideBar-item' onClick={() =>{navigate("/productos") ; setOpen(false)}}>
                <FaHouseChimney />
                <span>Inicio</span>
            </div> */}

            <div className='SideBar-item' onClick={() =>{navigate("/proximamente") ; setOpen(false)}}>
                <FaShop />
                <span>Catalogo</span>
            </div>

            {/* <div className='SideBar-item' onClick={() =>{navigate("/cartas"); setOpen(false)}}>
            <FaHandshake />
            <span>Sobre nosotros</span>
            </div> */}
        </div>


    </div>
    <div className='SideBar-Background' onClick={()=>{setOpen(false)}} style={{display:open ? "flex" : "none"}}>

    </div>
  
    </>
  )
}

export default Sidebar